document.addEventListener("alpine:init", () => {
    Alpine.data("glossaryItems", () => ({
        positionTop: 0,
        lastScrollTop: 0,
        navBar: null,
        currentLink: null,
        init() {
            this.navBar = this.$el;

            const navLinks = this.$refs.navLinks.querySelectorAll("a");

            this.currentLink = navLinks[0].getAttribute("href");

            navLinks.forEach((link) => {
                link.addEventListener("click", (e) => {
                    e.preventDefault();
                    const targetId = link.getAttribute("href").substring(1);
                    const targetEl = document.getElementById(targetId);
                    if (!targetEl) return;

                    const headerOffset = 160; // match your sticky header height
                    const elementPosition = targetEl.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.scrollY - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                    });
                });
            });

            this.checkPosition(true);
        },

        checkPosition(onLoad = false) {
            const contentRows = document.querySelectorAll(".Glossary__container");
            const windowOffset = window.innerHeight / 4; // more accurate than outerHeight
            const scrollY = window.scrollY;

            let activeLink = null;

            contentRows.forEach((row) => {
                if (!row.id) return;

                const rect = row.getBoundingClientRect();
                const rowTop = rect.top + scrollY;
                const rowBottom = rowTop + rect.height;

                // When scrolling down
                if (scrollY + windowOffset >= rowTop && scrollY + windowOffset <= rowBottom) {
                    activeLink = `#${row.id}`;
                }

                // When scrolling up
                if (scrollY + 10 >= rowTop && scrollY < rowBottom) {
                    activeLink = `#${row.id}`;
                }
            });

            // Fallback: top of page
            if (scrollY < 50) {
                const firstLink = this.$refs.navLinks.querySelector("a");
                activeLink = firstLink.getAttribute("href");
            }

            if (activeLink) {
                this.currentLink = activeLink;
            }

            this.lastScrollTop = scrollY;
        }
    }));
});
